var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.6016 7.26647L8.59121 13.2769C7.22437 14.6437 5.00829 14.6437 3.64146 13.2769C2.27462 11.91 2.27462 9.69396 3.64146 8.32713L9.65187 2.31672C10.5631 1.4055 12.0405 1.40549 12.9517 2.31672C13.8629 3.22794 13.8629 4.70533 12.9517 5.61655L7.17699 11.3913C6.72138 11.8469 5.98269 11.8469 5.52708 11.3913C5.07147 10.9356 5.07147 10.197 5.52708 9.74134L10.5947 4.67374",
    stroke: "#4B5565",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.05ea8fc1708ce3e3291c7111f8ec7127.svg";
export { ForwardRef as ReactComponent };